import { IFeatureFlags } from './feature-flags.types'

export const FEATURE_FLAGS_DEV: IFeatureFlags = {
  // SHARED
  ADMIN_FEE_RETURN_TO_CHECKOUT: 'true',
  ADMIN_FEE_LOYALTY: 'true',
  CHECKOUT_RESERVATIONS_DECOUPLING: 'true',
  CHECKOUT_RESERVATIONS_DECOUPLING_PHASE_TWO: 'false',
  SERVICING_AND_WARRANTY_FLAG: 'false',
  DISABLE_CINCHCARE: 'false',
  GAP_INSURANCE_FLAG: 'true',
  ENABLE_ZENDESK_SCRIPT: 'true',
  VEHICLE_CARD_V2: 'true',
  ENABLE_EMAIL_QUOTE: 'true',
  ENABLE_QUOTES_MARKETING: 'true',
  SHOW_QUOTE_TERM_MONTHS: 'true',
  SHOW_SCORELESS_TRUSTPILOT: 'true',
  SOFT_SEARCH_CHANGES: 'true',
  PDP_SOFT_SEARCH: 'true',
  SHOW_CINCH_COVER_IN_PROFILE: 'true',
  SHOW_TYRE_INSURANCE_IN_PROFILE: 'true',
  SHOW_MULTI_TERM_VAPS_IN_PROFILE: 'true',
  SHOW_GAP_INSURANCE_IN_PROFILE: 'true',
  SHOW_SELF_SERVICE_RENEWALS_V3: 'true',
  USE_REFRESH_TOKEN: 'true',
  SHOW_HELP_AND_SUPPORT_CHANGES: 'true',
  ENABLE_SEGMENT_TRACKING_IN_USED_CARS: 'true',
  ENABLE_SELL_MY_CAR: 'true',
  ENABLE_NEW_PROFILE_HEADER: 'false',
  FINANCE_APPLICATION_CHECKOUT_BANNER: 'true',
  CAR_FINANCE_SHOW_TRUST_PILOT: 'true',
  ENABLE_NEW_CARS_FINANCE: 'true',
  ENABLE_VAPS_FEATURE_CAR_MAINTENANCE: 'true',
  FIN_OFFER_COMMISSION: 'true',
  FINANCE_SOFT_SEARCH_V2: 'true',
  FINANCE_APPLICATION_ADDRESS_HISTORY_SUBBUILDING: 'true',
  ENABLE_SERVICE_BOOKING: 'true',
  PART_EX_EQUITY_RELEASE: 'true',
  HOME_HERO_FORM_WITH_NEW_CARS_TAB: 'true',
  DISPLAY_NEW_FOOTER: 'true',

  // ACQUISITION AND CONTENT
  HOMEPAGE_FAVOURITING: 'true',
}
